import React from "react";

export default function Install() {
  return (
    <div className="text-center" style={{minHeight:'100vh'}}>
      <br />
      <br />
      <br />
      <br />
      <br />
      <h3>Please install <a href="https://metamask.io/download.html">MetaMask</a></h3>
    </div>
  );
}
